import React from "react";
import { Box, Image, Text } from "@chakra-ui/react";
import InscriptionPercent from "./Analytics/InscriptionPercent";
import moment from "moment-with-locales-es6";

// export const ShowCompactEvents = ({ event }) => {
//   moment.locale("fr")
//   return (
//     <div style = {{margin:10}}>
//       <Image src={event.logo.url()} boxSize="80px" />
//       <br />
//       {event.id}
//       <br />
//       {event.title}
//       <br />
//       {event.date2}
//       <br />
//       {event.inscrits}
//       <br />
//       {event.adresse}
//       <br />
//       <Box bg="#white" h="100%" w="100%" borderRadius={"20px"}>
// <div align="center">
//   <InscriptionPercent
//     notDispo={event.inscrits}
//     dispo={event.nbInscritMax - event.inscrits}
//   ></InscriptionPercent>
// </div>
//       </Box>
//     </div>

export const ShowCompactEvents = ({ event }) => {
  const eventDate = new Date(event.date);
  const eventDateFormatted =
    eventDate.getDate() +
    "/" +
    (eventDate.getMonth() + 1) +
    "/" +
    eventDate.getFullYear();

  moment.locale("fr");
  return (
    <Box align="start">
      <Box w={"100%"}>
        <Image
          src={event.logo.url()}
          w={"100%"}
          h={"75px"}
          objectFit={"cover"}
          borderTopRadius={"20px"}
        />
        <Text
          bg={"#F1404B"}
          width={"60px"}
          color={"white"}
          align={"center"}
          position={"relative"}
          top={"-60px"}
          right={"70px"}
          borderRadius={"100px"}
        >
          {moment().month(event.date2).format("DD/MM")}
        </Text>
      </Box>
      <Box w={"100%"} px={5}>
        <Text
          align={"left"}
          fontWeight={900}
          fontFamily={"Sofia Pro"}
          fontSize={"l4px"}
        >
          {event.title}
        </Text>
        <Text
          align={"left"}
          fontWeight={400}
          fontFamily={"Sofia Pro"}
          noOfLines={1}
          lineHeight={1}
          my={1}
        >
          {event.adresse}
        </Text>
        <Box mt={4}>
          <InscriptionPercent
            notDispo={event.inscrits}
            dispo={event.nbInscritMax - event.inscrits}
          ></InscriptionPercent>
        </Box>
      </Box>
    </Box>
  );
};

export default ShowCompactEvents;
